"use client";

import { useEffect } from "react";
import { clientGet } from "@/service/client-api/client-api";

interface UserWithNewsletter {
  setUser?: (data: { newsletter?: boolean }) => void;
}

/**
 * Synchronizuje stan newslettera użytkownika z serwerem.
 * Pomija synchronizację dla akcji "login" (użytkownik niezalogowany).
 */
export function useSyncUserNewsletter(
  user: UserWithNewsletter,
  actionName: string | undefined,
) {
  useEffect(() => {
    if (!actionName || actionName === "login") {
      return;
    }

    const syncNewsletter = async () => {
      try {
        const userInfo = await clientGet("profile.info");
        user.setUser((draft) => {
          draft.newsletter = userInfo.newsletter;
        });
      } catch {
        // Ignoruj błędy - newsletter sync nie jest krytyczny
      }
    };

    syncNewsletter();
  }, [actionName, user]);
}
